/// Paleta categórica validada para daltonismo e contraste; ordem fixa, nunca ciclada.
const LIGHT = ['#2a78d6', '#eb6834', '#1baf7a', '#eda100', '#e87ba4', '#008300', '#4a3aa7', '#e34948'];
const DARK = ['#3987e5', '#d95926', '#199e70', '#c98500', '#d55181', '#008300', '#9085e9', '#e66767'];

export function categoricalPalette(darkMode: boolean): string[] {
    return darkMode ? DARK : LIGHT;
}

/// A partir da oitava categoria não se inventa cor nova: vira "Outros".
export const MAX_CATEGORIES = 8;

/// Cor fixa por origem, não por posição: filtrar não repinta o WhatsApp; o resto divide a oitava.
const SOURCE_SLOTS: Record<number, number> = {
    1: 0, // WhatsApp
    2: 1, // Anúncio
    4: 2, // Instagram
    0: 3, // Manual
    3: 4, // Site
    5: 5, // E-mail
    10: 6, // RD Station
};

export const OTHER_SLOT = MAX_CATEGORIES - 1;

export function sourceSlot(source: number): number {
    return SOURCE_SLOTS[source] ?? OTHER_SLOT;
}
